/* eslint-disable */

export default {
  init() {
    var idleTime = 0;

    $(window).load(function () {
      function timerIncrement() {
        idleTime = idleTime + 1;

        if (idleTime == 1) {
          if (
            !$('.exit-popup').hasClass('visible') &&
            !localStorage.getItem('exit-popup')
          ) {
            $('.exit-popup').addClass('visible');
            localStorage.setItem('exit-popup', 1);
          }
        }
      }

      //Zero the idle timer on mouse movement.
      $(document).on('mousemove', function (e) {
        idleTime = 0;
      });
      $(document).on('keypress', function (e) {
        idleTime = 0;
      });
      $(document).on('touchstart', function (e) {
        idleTime = 0;
      });
      $(document).on('touchmove', function (e) {
        idleTime = 0;
      });

      //Increment the idle time counter every minute.
      if (window.innerWidth <= 767) {
        setInterval(timerIncrement, 10000);
      }

      var addEvent = function (obj, evt, fn) {
        if (obj.addEventListener) {
          obj.addEventListener(evt, fn, false);
        } else if (obj.attachEvent) {
          obj.attachEvent('on' + evt, fn);
        }
      };

      // addEvent(document, 'mouseout', function (event) {
      //   event = event ? event : window.event;
      //   var from = event.relatedTarget || event.toElement;

      //   if ((!from || from.nodeName == 'HTML') && event.clientY <= 100) {
      //     if (
      //       !$('.exit-popup').hasClass('visible') &&
      //       !localStorage.getItem('exit-popup')
      //     ) {
      //       $('.exit-popup').addClass('visible');
      //       localStorage.setItem('exit-popup', 1);
      //     }
      //   }
      // });

      $('.exit-popup-body-close').on('click', (e) => {
        e.preventDefault();

        $('.exit-popup').removeClass('visible');
      });

      if (
        document.querySelector(
          'body > div.bottom-container > div > div.right-side > button'
        )
      ) {
        const bottomPopUpButton = document.querySelector(
          'body > div.bottom-container > div > div.right-side > button'
        );
        bottomPopUpButton.addEventListener('click', function () {
          document.querySelector(
            'body > div.bottom-container > div'
          ).style.display = 'none';
        });
        let avivSale = document
          .querySelector('body > div.bottom-container')
          .getAttribute('data');
        document
          .querySelector(
            'body > div.bottom-container > div > div.right-side > div'
          )
          .addEventListener('click', function () {
            window.open(avivSale);
          });
        document
          .querySelector(
            'body > div.bottom-container > div > div.left-side > div'
          )
          .addEventListener('click', function () {
            window.open(avivSale);
          });
        document
          .querySelector(
            'body > div.bottom-container > div > div.right-side > img'
          )
          .addEventListener('click', function () {
            window.open(avivSale);
          });
      }

      const queryStringsInURL = window.location.href.split('?')[1];

      if (queryStringsInURL) {
        sessionStorage.setItem('queryString', '?' + queryStringsInURL);
      }

      const queryStringsInSession = sessionStorage.getItem('queryString');

      if (queryStringsInSession && !queryStringsInURL) {
        window.history.pushState(
          {},
          null,
          `${window.location.href}${queryStringsInSession}`
        );
      }
    });

    $(window).on('scroll', function () {
      const scrollTop = $(this).scrollTop();
      const header = $('.site-header');

      if (!header.length) {
        return;
      }

      if (scrollTop > 400) {
        header.css('background-color', 'rgba(0, 0, 0, 1)');
        header.css('box-shadow', '-1px 0px 9px -4px rgba(0, 0, 0, 1)');
        return;
      }

      const percent = scrollTop / 400;

      header.css('background-color', `rgba(0, 0, 0, ${percent})`);
      header.css('box-shadow', `-1px 0px 9px -4px rgba(0, 0, 0, ${percent})`);
    });

    document.querySelectorAll('input.wpcf7-submit').forEach(function (button) {
      button.removeAttribute('disabled');
    });

    // Loop through each form control
    document
      .querySelectorAll('.wpcf7-form-control')
      .forEach(function (control) {
        // Add an event listener for the 'change' event
        control.addEventListener('keyup', function () {
          document
            .querySelectorAll('input.wpcf7-submit')
            .forEach(function (button) {
              button.removeAttribute('disabled');
            });
        });

        control.addEventListener('blur', function () {
          document
            .querySelectorAll('input.wpcf7-submit')
            .forEach(function (button) {
              button.removeAttribute('disabled');
            });
        });

        control.addEventListener('change', function () {
          document
            .querySelectorAll('input.wpcf7-submit')
            .forEach(function (button) {
              button.removeAttribute('disabled');
            });
        });
      });

    document.querySelectorAll('.wpcf7').forEach(function (el) {
      el.addEventListener(
        'wpcf7mailsent',
        function () {
          if (window.location.pathname !== '/register/') {
            window.location.href = window.siteData.thank_you;
          } else if (window.location.pathname === '/register/') {
            window.location.href = '/thank-you-2';
          }
          if (window.location.pathname === '/') {
            window.location.href = '/thanks';
          }

          // const formData = new FormData($(el).find('form').get(0)); // Get form data
          // const jsonData = Object.fromEntries(formData.entries()); // Convert to JSON

          // // Filter out keys that start with _wpcf7
          // const filteredData = Object.keys(jsonData).reduce((acc, key) => {
          //   if (!key.startsWith('_wpcf7')) {
          //     acc[key] = jsonData[key];
          //   }
          //   return acc;
          // }, {});

          // fetch(
          //   'https://pitangoux.odoo.com/web/hook/9b9ed6fe-cdba-4f39-b414-ab9e465b29dc',
          //   {
          //     method: 'POST',
          //     headers: {
          //       'Content-Type': 'application/json',
          //     },
          //     body: JSON.stringify(filteredData), // Send the form data as JSON
          //   }
          // )
          //   .then((response) => {
          //     if (response.ok) {
          //       return response.json();
          //     } else {
          //       throw new Error('Network response was not ok');
          //     }
          //   })
          //   .then((data) => {
          //     if (window.location.pathname !== '/register/') {
          //       window.location.href = window.siteData.thank_you;
          //     } else if (window.location.pathname === '/register/') {
          //       window.location.href = '/thank-you-2';
          //     }
          //     if (window.location.pathname === '/') {
          //       window.location.href = '/thanks';
          //     }
          //   })
          //   .catch((error) => {
          //     if (window.location.pathname !== '/register/') {
          //       window.location.href = window.siteData.thank_you;
          //     } else if (window.location.pathname === '/register/') {
          //       window.location.href = '/thank-you-2';
          //     }
          //     if (window.location.pathname === '/') {
          //       window.location.href = '/thanks';
          //     }
          //   });
        },
        false
      );
    });

    this._siteTabs();
    this._consultForm();
    this._fullHeaderContact();
    this._floatingContact();
    this._sharePopup();
    this._footerLinks();
    this._mobileMenuToggle();
    this._contactFormSubjectPlaceholder();
    this._blogToggleCategories();
  },
  _blogToggleCategories() {
    $('.categories-show-more').on('click', function () {
      const catsWrap = $('.blog-categories-wrap');

      if (!catsWrap.length) {
        return;
      }

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        catsWrap.animate({ 'max-height': 34 }, { queue: false, duration: 250 });
      } else {
        $(this).addClass('active');
        catsWrap.animate(
          { 'max-height': 1500 },
          { queue: false, duration: 1000 }
        );
      }
    });
  },
  _contactFormSubjectPlaceholder() {
    if ($('body').hasClass('template-contact')) {
      $('.contact-form .wpcf7 span.subject select option:first').html(
        'סיבת הפנייה'
      );
    }
  },
  _mobileMenuToggle() {
    $(window).load(() => {
      $('.header-menu .menu-container').prepend(
        '<div class="header-menu-close"></div>'
      );
    });

    const closeHeaderMenu = () => {
      const headerMenu = $('.header-menu');

      headerMenu.addClass('animate-out');

      setTimeout(() => {
        headerMenu.removeClass('active');
        headerMenu.removeClass('animate-out');
      }, 200);
    };

    $(document).on('click', '.site-header .header-menu-close', function () {
      closeHeaderMenu();
    });

    $('.site-header .header-menu-toggle').on('click', function () {
      $('.header-menu').addClass('active');
    });

    $('.site-header .header-menu').on('click', function (e) {
      if ($(e.target).parents('ul.nav').length || $(e.target).hasClass('nav')) {
        return;
      }

      closeHeaderMenu();
    });
  },
  _footerLinks() {
    $('.footer-menus-wrap .widget_nav_menu > h3').on('click', function () {
      if ($(window).width() > 767) {
        return;
      }

      $('.footer-menus-wrap .widget_nav_menu > h3')
        .not($(this))
        .removeClass('active')
        .next('div')
        .slideUp(200);

      $(this).next('div').stop().slideToggle(200);
      $(this).toggleClass('active');
    });
  },
  _floatingContact() {
    $(window).on('scroll', function () {
      const scrollTop = $(this).scrollTop();
      const floatingContact = $('.mobile-floating-contact');

      if (!floatingContact.length) {
        return;
      }

      if (scrollTop > 45 && !floatingContact.hasClass('active')) {
        floatingContact.addClass('active');
      } else if (scrollTop <= 45 && floatingContact.hasClass('active')) {
        floatingContact.removeClass('active');
      }
    });
  },
  _fullHeaderContact() {
    $('.full-page-header-contact .contact-toggle').on('click', function () {
      var h = window.innerHeight;
      if (h < 640) {
        alert('x');
      }
      $(this).parent().toggleClass('active-side');
    });

    $('.full-page-header-contact a').on('click', function () {
      $(this).parent().toggleClass('active');
    });
  },
  _sharePopup() {
    $('.share-popup-toggle').on('click', function () {
      $(this).next('.share-popup').toggleClass('active');
    });

    $('.share-popup a.copy').on('click', function (e) {
      e.preventDefault();
      const copyText = $(this).attr('href');

      document.addEventListener(
        'copy',
        function (e) {
          e.clipboardData.setData('text/plain', copyText);
          e.preventDefault();
        },
        true
      );

      document.execCommand('copy');
      $(this).parent().toggleClass('active');
    });
  },
  _consultForm() {
    $('.exit-popup-body-contact').on('click', function () {
      $('html, body').animate(
        {
          scrollTop: $('.site-footer').offset().top,
        },
        1500
      );
      $('.exit-popup').removeClass('visible');
    });

    $('.page-consult-action').on('click', function () {
      $('.signup-form-title').scroll();
      $('html, body').animate(
        {
          scrollTop: $('.site-footer').offset().top,
        },
        1500
      );
    });

    $('.mobile-toggle-consult').on('click', function () {
      $('.free-consult-form').addClass('active');
    });

    $('.free-consult-form').on('click', function (e) {
      if (
        $(e.target).parents('.wpcf7').length ||
        $(e.target).hasClass('.consult-form-wrap')
      ) {
        return;
      }

      $('.free-consult-form').removeClass('active');
    });

    $(window).load(function () {
      const consultAction = $('.page-consult-action');

      if (!consultAction.length) {
        return;
      }

      consultAction.data('top', consultAction.offset().top);
    });

    $(window).on('scroll', function () {
      const scrollTop = $(this).scrollTop();
      const consultAction = $('.page-consult-action');

      if (!consultAction.length) {
        return;
      }

      const consultActionTopOriginal = consultAction.data('top');
      const header = $('.site-header');

      if (consultAction.offset().top < consultActionTopOriginal) {
        consultAction.css('top', '100%');
        return;
      }

      if (scrollTop > consultActionTopOriginal) {
        consultAction.css(
          'top',
          `${scrollTop + header.height() + consultAction.height()}px`
        );
      } else {
        consultAction.css('top', '120%');
      }
    });
  },
  _siteTabs() {
    $('.site-general-tabs').each(function (index, $tabs) {
      if ($($tabs).hasClass('is-links')) {
        return;
      }

      const tabId = $($tabs).data('tabs');

      const generalItems = $(`.site-general-items[data-tabs=${tabId}]`);

      $($tabs).find('a[data-index=0]').addClass('active');
      generalItems.find('.site-general-item[data-index=0]').addClass('active');
    });

    $('.site-general-tabs a').on('click', function (e) {
      if ($(this).parent().hasClass('is-links')) {
        if ($(this).parent().hasClass('mixitup')) {
          e.preventDefault();
        }

        return;
      }

      e.preventDefault();

      $(this).parent().trigger('change');

      const tabId = $(this).parent().data('tabs');
      const index = $(this).data('index');
      const generalItems = $(`.site-general-items[data-tabs=${tabId}]`);

      $(`.site-general-tabs[data-tabs=${tabId}] a`).removeClass('active');
      $(
        `.site-general-tabs[data-tabs=${tabId}] a[data-index=${index}]`
      ).addClass('active');

      generalItems.find('.site-general-item').removeClass('active');
      generalItems
        .find(`.site-general-item[data-index=${index}]`)
        .addClass('active');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
$(window).on('scroll', function () {
  const scrollTop = $(this).scrollTop();
  const floatingContact = $('.full-page-header-contact');

  if (!floatingContact.length) {
    return;
  }

  if (scrollTop > 45 && !floatingContact.hasClass('active-scroll')) {
    floatingContact.addClass('active-scroll');
  } else if (scrollTop <= 45 && floatingContact.hasClass('active-scroll')) {
    floatingContact.removeClass('active-scroll');
  }
});



// WEBPACK FOOTER //
// ./scripts/routes/common.js